// スライダー
import slick from "slick-carousel";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export function idxFunc() {
  if (!$("#indexTop").length) return;

  const setUpAccordion = () => {
    const details = document.querySelectorAll(".accordion");
    const IS_OPENED_CLASS = "isOpen";
    const IS_ANIMATING_CLASS = "is-animating";

    details.forEach((element) => {
      const summary = element.querySelector(".accordionBtn");
      const content = element.querySelector(".accordionCon");

      summary.addEventListener("click", (event) => {
        event.preventDefault();

        // アニメーション中は無効
        if (element.classList.contains(IS_ANIMATING_CLASS)) return;

        element.classList.add(IS_ANIMATING_CLASS);

        if (element.classList.contains(IS_OPENED_CLASS)) {
          // 閉じる
          const contentHeight = content.scrollHeight;

          content.style.height = contentHeight + "px";

          // reflow
          content.offsetHeight;

          content.style.height = "0";
          content.style.opacity = "0";

          element.classList.remove(IS_OPENED_CLASS);

          const onClose = (e) => {
            if (e.propertyName !== "height") return;

            element.removeAttribute("open");
              ScrollTrigger.refresh();

            content.removeEventListener("transitionend", onClose);

            element.classList.remove(IS_ANIMATING_CLASS);
          };

          content.addEventListener("transitionend", onClose);
        } else {
          // 開く
          element.setAttribute("open", "true");

          content.style.height = "0";
          content.style.opacity = "0";

          // reflow
          content.offsetHeight;

          const contentHeight = content.scrollHeight;

          content.style.height = contentHeight + "px";
          content.style.opacity = "1";

          element.classList.add(IS_OPENED_CLASS);

          const onOpen = (e) => {
            if (e.propertyName !== "height") return;

            content.style.height = "auto";
            ScrollTrigger.refresh();

            content.removeEventListener("transitionend", onOpen);

            element.classList.remove(IS_ANIMATING_CLASS);
          };

          content.addEventListener("transitionend", onOpen);
        }
      });
    });
  };
  setUpAccordion();

  const fvSlide = $(".fvSlide");

  if (fvSlide.length && !fvSlide.hasClass("slick-initialized")) {
    fvSlide.on("init", function () {
      $(this).addClass('zoomIn');
    }).slick({
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      fade: true,
      infinite: true,
      touchMove: false,
      swipe: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
    }).on('beforeChange',function(event, slick, currentSlide, nextSlide){

      $(slick.$slides).removeClass('zoomOut');
      $(slick.$slides[currentSlide]).addClass('zoomOut');

      $('.fv .copyRight').removeClass('pink');
      $('.fvSp .copyRight').removeClass('pink');

      if(nextSlide === 1 ) {
        $('.fv .copyRight').addClass('pink');
        $('.fvSp .copyRight').addClass('pink');
      }

    });
  }

  // slideArea1
  const $slider1 = $(".slideArea");

  if ($slider1.length && !$slider1.hasClass("slick-initialized")) {
    $slider1.slick({
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 400,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      arrows: true,
      dots: true,
      fade: false,
      infinite: true,
      pauseOnTouchMove: false,
      pauseOnHover: false,
      nextArrow: '<img src="/s/garrack/feature/madokamagica/images/common/slide_arrow_next.svg" class="slide-arrow next-arrow">',
      prevArrow: '<img src="/s/garrack/feature/madokamagica/images/common/slide_arrow_prev.svg" class="slide-arrow prev-arrow">',
    });

    // dotsにclass付与
    $slider1.find(".slick-dots li").each(function (index) {
      $(this).addClass(`dot-${index + 1}`);
    });
  }

  const $slider2 = $(".slideArea02");
  if ($slider2.length && !$slider2.hasClass("slick-initialized")) {
    $slider2.slick({
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 400,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      arrows: true,
      dots: true,
      fade: false,
      infinite: true,
      pauseOnTouchMove: false,
      pauseOnHover: false,
      variableWidth: true,
      nextArrow: '<img src="/s/garrack/feature/madokamagica/images/common/slide_arrow_next.svg" class="slide-arrow next-arrow">',
      prevArrow: '<img src="/s/garrack/feature/madokamagica/images/common/slide_arrow_prev.svg" class="slide-arrow prev-arrow">',
    });

    // dotsにclass付与
    $slider2.find(".slick-dots li").each(function (index) {
      $(this).addClass(`dot-${index + 1}`);
    });
  }
}
